const state = {
  error: {},
};

const mutations = {
  setError(currentState, error) {
    window.parent.postMessage('error', '*');
    currentState.error = error;
  },
};

export { mutations, state };
